import ConfigManager from './config.manager';
export const config = (key) => ConfigManager.config(key);
export const configAsNumber = (key, defaultValue) => {
    const configValue = ConfigManager.config(key);
    return !configValue || isNaN(configValue) ? defaultValue : Number(configValue);
};
export const encrypt = (plainText) => ConfigManager.encrypt(plainText);
export const decrypt = (cipherText) => ConfigManager.decrypt(cipherText);
